<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''"
         v-bind:style="{cursor:pointer2}">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        {{title}}
                    </h3>
                    <h4 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        {{$formatCurrency(amount)}}
                    </h4>
                </div>
                <div class="col text-right">
                    <base-button type="primary" size="sm" v-on:click="onNewItem">Nuevo</base-button>
                </div>
            </div>
        </div>

        <div class="table-responsive" v-bind:style="{cursor:pointer}">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="data"
                        v-on:click="paymentSelected">

                <template slot="columns">
                    <th v-bind:style="{cursor:pointer2}">Depósito</th>
                    <th v-bind:style="{cursor:pointer2}">Fecha</th>
                    <th v-bind:style="{cursor:pointer2}">Cantidad</th>
                    <th v-bind:style="{cursor:pointer2}">Validado</th>
                    <th v-bind:style="{cursor:pointer2}">Creado el</th>
                </template>

                <template slot-scope="{row}">
                    <th scope="row">
                        <div class="media align-items-center">
                            <div class="media-body">
                                <span class="name mb-0 text-sm">{{row.id}}</span>
                            </div>
                        </div>
                    </th>
                    <td>{{formatDate(row.date)}}</td>
                    <td>{{$formatCurrency(row.amount)}}</td>
                    <td>
                        <div class="d-flex align-items-center">
                            <span v-bind:class="getValidatedClass(row.validated)">{{row.validated ? "Validado": "No validado"}}</span>
                        </div>
                    </td>
                    <td>{{formatDate(row.created)}}</td>

                </template>

            </base-table>
        </div>

        <div v-if="pagination.total > pagination.perPage" class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination
                    size="sm"
                    :total="pagination.total"
                    :per-page="pagination.perPage"
                    :value="pagination.currentPage"
                    v-on:pageSelected="pageSelected"/>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'clients-table',
        props: {
            type: {
                type: String
            },
            title: String,
            amount: Number,
            data: Array,
            pagination: Object
        },
        data() {
            return {
                tableData: [],
                pointer: 'pointer',
                pointer2: 'default'
            }
        },
        computed: {
            banks() { return this.$store.state.banks }
        },
        async created() { },
        methods: {
            pageSelected(page) {
                this.$emit("pageSelected", page);
            },
            getValidatedClass(validated) {
                if (validated) return "text-success"
                return "text-danger"
            },
            formatCurrency(value) {
                return this.$formatCurrency(value)
            },
            getBanks(array) {
                let banks = []
                for (let a=0 ; a<=array.length ; a++) {
                    for (let b = 0; b < this.banks.length; b++) {
                        if (this.banks[b].id === array[a]) {
                            banks.push(this.banks[b])
                            break
                        }
                    }
                }
                return banks
            },
            formatDate(date) {
//                return this.$moment(date).format("DD MMM, YYYY")
               return this.$formatDate(date)
            },
            onNewItem() {
                this.$emit("onNewItem")
            },
            paymentSelected(payment) {
                this.$emit("onPaymentSelected", payment)
            }
        }
    }
</script>
<style>
</style>
